module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-md font-medium text-white py-2 px-5 rounded mt-4 cursor-pointer flex justify-between",
    class: _vm.show_div ?
      'bg-theme-1 text-white' :
      'bg-white border border-theme-1 text-theme-1 hover:bg-theme-1 hover:text-white',
    on: {
      "click": function($event) {
        _vm.show_div = !_vm.show_div
      }
    }
  }, [_c('span', {
    staticClass: "my-auto"
  }, [_vm._v(_vm._s(_vm.show_div ? 'Ocultar' : 'Ver') + " listado")]), _vm._v(" "), _c('span', {
    staticClass: "font-bold text-lg"
  }, [_vm._v(_vm._s(_vm.show_div ? '-' : '+'))])]), _vm._v(" "), (_vm.createTaskModalOption) ? _c('CreateTaskModal', {
    attrs: {
      "task_current": _vm.task_current
    },
    on: {
      "closeModal": function($event) {
        return _vm.setCreateTaskModal(false)
      },
      "secondPlanningCreated": function($event) {
        return _vm.secondPlanningCreated()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_div && !_vm.createTaskModalOption) ? _c('div', {
    staticClass: "overflow-auto intro-y"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("TAREA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("HORAS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [(_vm.filter_date) ? _c('div', {
    staticClass: "flex justify-center gap-2 cursor-pointer hover:text-theme-1",
    on: {
      "click": function($event) {
        _vm.filter_date = !_vm.filter_date
      }
    }
  }, [_vm._v("\n              FECHA\n              "), _c('svg', {
    staticClass: "w-4 h-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M3.792 2.938A49.069 49.069 0 0 1 12 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 0 1 1.541 1.836v1.044a3 3 0 0 1-.879 2.121l-6.182 6.182a1.5 1.5 0 0 0-.439 1.061v2.927a3 3 0 0 1-1.658 2.684l-1.757.878A.75.75 0 0 1 9.75 21v-5.818a1.5 1.5 0 0 0-.44-1.06L3.13 7.938a3 3 0 0 1-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836Z",
      "clip-rule": "evenodd"
    }
  })])]) : _c('div', {
    staticClass: "flex justify-center gap-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.date),
      expression: "filter.date"
    }],
    staticClass: "input w-full border mt-2 flex-1 text-center",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.filter.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "w-4 h-4 my-auto cursor-pointer hover:text-theme-1",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    },
    on: {
      "click": function($event) {
        return _vm.closeFilterDate()
      }
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
      "clip-rule": "evenodd"
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap w-40"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.account_id),
      expression: "filter.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1 text-center",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-",
      "selected": ""
    }
  }, [_vm._v("CUENTAS")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: ("account-" + (account.id)),
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                " + _vm._s(account.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap w-40"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.user_id),
      expression: "filter.user_id"
    }],
    staticClass: "input w-full border mt-2 flex-1 text-center",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-",
      "selected": ""
    }
  }, [_vm._v("ASIGNADO")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      key: ("user-" + (user.id)),
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                " + _vm._s(user.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredItems), function(item, index) {
    return _c('tr', {
      key: 'list' + index,
      staticClass: "intro-x"
    }, [_c('td', [(_vm.editIndex === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_planning.task),
        expression: "current_planning.task"
      }],
      class: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "required": ""
      },
      domProps: {
        "value": (_vm.current_planning.task)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.current_planning, "task", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap flex gap-1",
      class: item.task_created ? 'text-theme-1' : ''
    }, [(item.planning_id) ? _c('app-icon', {
      attrs: {
        "name": 'check-circle',
        "classname": 'w-5 h-5 text-theme-9'
      }
    }) : _vm._e(), _vm._v(" "), (item.task_created) ? _c('app-icon', {
      attrs: {
        "name": 'check-circle',
        "classname": 'w-5 h-5 text-theme-1'
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm._f("limit")(item.task)) + "\n            ")], 1)]), _vm._v(" "), _c('td', {
      staticClass: "w-32"
    }, [(_vm.editIndex === index && [2, 3].includes(_vm.user.team_id)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_planning.hours),
        expression: "current_planning.hours"
      }],
      class: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.current_planning.hours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.current_planning, "hours", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center"
    }, [_vm._v("\n              " + _vm._s(item.hours) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-24"
    }, [(_vm.editIndex === index && [2, 3].includes(_vm.user.team_id)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_planning.date),
        expression: "current_planning.date"
      }],
      class: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "date",
        "required": ""
      },
      domProps: {
        "value": (_vm.current_planning.date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.current_planning, "date", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center"
    }, [_vm._v("\n              " + _vm._s(item.date) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40"
    }, [(_vm.editIndex === index && [2, 3].includes(_vm.user.team_id)) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_planning.account_id),
        expression: "current_planning.account_id"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.current_planning, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
      return _c('option', {
        key: ("account-" + (account.id)),
        domProps: {
          "value": account.id
        }
      }, [_vm._v("\n                " + _vm._s(account.name) + "\n              ")])
    })], 2) : _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center"
    }, [_vm._v("\n              " + _vm._s(item.account.name) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-20"
    }, [(_vm.editIndex === index && [2, 3].includes(_vm.user.team_id)) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_planning.user_id),
        expression: "current_planning.user_id"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.current_planning, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
      return _c('option', {
        key: ("user-" + (user.id)),
        domProps: {
          "value": user.id
        }
      }, [_vm._v("\n                " + _vm._s(user.name) + "\n              ")])
    })], 2) : _c('div', {
      staticClass: "w-24 h-24 lg:w-12 lg:h-12 image-fit mx-auto"
    }, [(item.created_user) ? _c('img', {
      staticClass: "rounded-full mx-auto -ml-6",
      attrs: {
        "title": item.created_user.name,
        "src": item.created_user.avatar
      }
    }) : _vm._e(), _vm._v(" "), (item.user) ? _c('img', {
      staticClass: "rounded-full mx-auto",
      attrs: {
        "title": item.user.name,
        "src": item.user.avatar
      }
    }) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action text-center"
    }, [(_vm.editIndex === index) ? _c('button', {
      staticClass: "bg-green-400 text-white rounded py-1 px-2 text-xs",
      on: {
        "click": function($event) {
          return _vm.updateItem()
        }
      }
    }, [_vm._v("\n              Guardar\n            ")]) : _c('button', {
      staticClass: "bg-theme-1 text-white rounded py-1 px-2 text-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editItem(index, item)
        }
      }
    }, [_vm._v("\n              Editar\n            ")]), _vm._v(" "), ([2, 3].includes(_vm.user.team_id)) ? _c('button', {
      staticClass: "bg-red-600 text-white rounded py-1 px-2 text-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(item)
        }
      }
    }, [_vm._v("\n              Eliminar\n            ")]) : _vm._e(), _vm._v(" "), (!item.task_created) ? _c('button', {
      staticClass: "bg-theme-3 text-white rounded py-1 px-2 text-xs",
      on: {
        "click": function($event) {
          return _vm.openCreateTask(item)
        }
      }
    }, [_vm._v("\n              Crear Tarea\n            ")]) : _vm._e(), _vm._v(" "), (item.number_versions == 0) ? _c('button', {
      staticClass: "bg-theme-11 text-white rounded py-1 px-2 text-xs",
      on: {
        "click": function($event) {
          return _vm.newVersion(item)
        }
      }
    }, [_vm._v("\n              Nueva Versión\n            ")]) : _vm._e()])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47e1f004","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/planning/ListPlanning.vue
// module id = 436
// module chunks = 1